/**
 * 产品信息配置
 * 用于存储产品相关的公共变量
 */

var productInfo = {
    ProductCode: 'a25fe6b243e72b5e', // 产品代码
    Name: '测试产品', // 产品名称
    Description : '测试产品', // 产品描述
    Avatar : 'https://prod.adobeccstatic.com/unav/assets/ec_appicon_noshadow_128.png', // 产品图标

}


export default productInfo


// WEBPACK FOOTER //
// ./src/utils/product_info.js